import { onPageIn, onMount, onDestroy } from '@/modules/_'

export default function (element: HTMLElement, dataset: DOMStringMap) {
  let tabButtons: NodeListOf<HTMLElement>
  let tabPanels: NodeListOf<HTMLElement>
  let cleanupFunctions: (() => void)[] = []

  const showTab = (tabName: string) => {
    // Hide all panels by adding u-display-none
    tabPanels.forEach((panel) => {
      const panelTab = panel.getAttribute('data-tab')

      if (panelTab === tabName) {
        panel.classList.remove('u-display-none')
        panel.style.opacity = '1'
      } else {
        panel.classList.add('u-display-none')
        panel.style.opacity = '0'
      }
    })

    // Update active state on buttons
    tabButtons.forEach((button) => {
      const menuLink = button.getAttribute('data-menu-link')
      if (menuLink === tabName) {
        button.classList.add('active-filter')
      } else {
        button.classList.remove('active-filter')
      }
    })
  }

  onMount(() => {
    tabButtons = element.querySelectorAll('[data-menu-link]')
    tabPanels = element.querySelectorAll('[data-tab]')

    // Add transition and hide all panels initially
    tabPanels.forEach((panel) => {
      panel.style.transition = 'opacity 0.4s ease'
      panel.classList.add('u-display-none')
      panel.style.opacity = '0'
    })

    // Show featured by default
    showTab('featured')

    // Add click handlers
    tabButtons.forEach((button) => {
      const handleClick = (e: Event) => {
        e.preventDefault()
        const tabName = button.getAttribute('data-menu-link')
        if (tabName) {
          showTab(tabName)
        }
      }

      button.addEventListener('click', handleClick)
      cleanupFunctions.push(() =>
        button.removeEventListener('click', handleClick)
      )
    })
  })

  onDestroy(() => {
    cleanupFunctions.forEach((cleanup) => cleanup())
    cleanupFunctions = []
  })
}
